import { apiRequest } from './client';
import type { ProjectView, UpdateProjectRequest } from './types';

export const projects = {
  list: (organizationId: string) =>
    apiRequest<ProjectView[]>('/api/projects', { organizationId }),

  update: (organizationId: string, projectId: string, body: UpdateProjectRequest) =>
    apiRequest<ProjectView>(`/api/projects/${projectId}`, {
      method: 'PATCH',
      organizationId,
      body,
    }),

  branches: (organizationId: string, projectId: string) =>
    apiRequest<string[]>(`/api/projects/${projectId}/branches`, { organizationId }),
};
